import { render, staticRenderFns } from "./IDCardModal.vue?vue&type=template&id=973ac5fc&"
import script from "./IDCardModal.vue?vue&type=script&lang=js&"
export * from "./IDCardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports